import {Grid, Tabs, UnstableCard as Paper} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import {Body, Header, IconNumber} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'
import {DestinationPointDeliveryMethod} from 'src/shared/types'

import {BusinessBannerModal} from '../../BusinessBannerModal/BusinessBannerModal'
import {PointContact} from '../../PointContact/PointContact'
import {PointPickUp} from '../../PointPickUp/PointPickUp'
import type {Props} from '../types'
import {useDestinationPointNdd} from './hooks'
import {translations} from './i18n'

export const DestinationPointNdd = memo<Props>(function DestinationPointNddDesktop(props) {
  const {name} = props
  const {
    isBannerVisible,
    toggleBannerVisibilityHandler,
    handleDeliveryMethodChange,
    tabs,
    orderNumber,
    handleBannerActionButtonClick,
  } = useDestinationPointNdd(props)

  return (
    <>
      <Paper radius="L">
        <Grid data-e2e={`destination-point-${orderNumber}`} size="m" container>
          <Grid xs={12} item>
            {/* заголовок с табами через Body рисуется лучше */}
            <Body
              tail={
                tabs ? (
                  <Tabs.Segments<string>
                    items={tabs}
                    onChange={handleDeliveryMethodChange}
                    size="m"
                    value={DestinationPointDeliveryMethod.PickUpPoint}
                  />
                ) : (
                  <React.Fragment />
                )
              }
            >
              <Header lead={<IconNumber number={orderNumber} variant="black" />}>
                {i18n('cargo.create.destinations.to', 'Куда')}
              </Header>
            </Body>
          </Grid>
          <PointPickUp name={`${name}.pickUpPoint`} />
          <Grid xs={12} item>
            <PointContact
              name={`${name}.contact`}
              title={i18n('cargo.create.destinations.recipient', 'Получатель')}
              isDetailsToggleHidden
            />
          </Grid>
        </Grid>
      </Paper>
      <BusinessBannerModal
        description={translations.description}
        imageSrc={translations.imageSrc}
        list={translations.list}
        onActionButtonClick={handleBannerActionButtonClick}
        onClose={toggleBannerVisibilityHandler}
        opened={isBannerVisible}
        title={translations.title}
        utmSource="order_d2d"
      />
    </>
  )
})
